import React, { useEffect, useRef } from "react";
import maplibregl from "maplibre-gl";

import { MapContainer } from "./LocationMap.styles";

import "maplibre-gl/dist/maplibre-gl.css";

export interface LocationMapProps {
  latitude: number;
  longitude: number;
}

const LocationMap: React.FC<LocationMapProps> = ({ latitude, longitude }) => {
  const mapContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const map = new maplibregl.Map({
      container: mapContainerRef.current!,
      style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
      center: [longitude, latitude],
      zoom: 15,
      interactive: false,
    });

    const marker = new maplibregl.Marker().setLngLat([longitude, latitude]);

    marker.addTo(map);

    return () => {
      map.remove();
    };
  }, [latitude, longitude]);

  return <MapContainer ref={mapContainerRef} />;
};

export default LocationMap;
